export const BANK_STATUS = {
	Active: 1,
	Inactive: 2,
};
